import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=6078ba43&"
import script from "./CustomField.vue?vue&type=script&lang=js&"
export * from "./CustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6078ba43')) {
      api.createRecord('6078ba43', component.options)
    } else {
      api.reload('6078ba43', component.options)
    }
    module.hot.accept("./CustomField.vue?vue&type=template&id=6078ba43&", function () {
      api.rerender('6078ba43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/CustomField.vue"
export default component.exports